module.exports = __webpack_public_path__ + "static/media/loading.0ec304a7.gif";